import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { GlobalFooter } from '@nexus/fff-global-footer';

import { receiveCampaign } from 'services/actions/campaignActions';
import { getCampaign } from 'services/api/campaign';
import withDocumentTitle from 'HOC/withDocumentTitle/withDocumentTitle';
import withViewSize from 'HOC/withViewSize/withViewSize';
import { receiveOrderConfirmation } from 'services/actions/invoicesActions';
import { selectPageTrackingFullData } from 'selectors/trackingSelector';
import { SUBSCRIPTION_STATUS } from 'utils/user';
import env from 'utils/env';
import { CAMPAIGN_TYPE } from 'utils/campaign';

import GlobalNav from 'shared-components/GlobalNav/GlobalNav';
import PastDue from 'shared-components/PastDue/PastDue';
import Checkout from './Checkout';

const CheckoutPage = ({
  viewSize,
  trackingData,
  receiveOrderConfirmation,
  receiveCampaign,
  campaignId,
  user,
}) => {
  const { freeTierEvergreenShopAccess: freeTierEvergreenShopAccessFF } =
    useFlags();

  const { isAccountPastDue, shippingAddress, subscriptionState, userId } = user;
  const isDesktop = viewSize === 'xLarge';
  const isExpired = subscriptionState === SUBSCRIPTION_STATUS.expired;

  useEffect(() => {
    const fetchCampaign = async () => {
      const response = await getCampaign(CAMPAIGN_TYPE.shop);
      receiveCampaign(response);
    };
    fetchCampaign();
  }, []);

  // redirect expired users to reactivation page if FF is OFF
  useEffect(() => {
    if (isExpired && !freeTierEvergreenShopAccessFF) {
      window.location.replace(
        `https://${env.hostname}/reactivate-my-membership`
      );
    }
  }, [isExpired, freeTierEvergreenShopAccessFF]);

  return (
    <>
      <div className={viewSize}>
        {isDesktop && <GlobalNav hideCart />}
        <Checkout
          shippingAddress={shippingAddress}
          isDesktop={isDesktop}
          trackingData={trackingData}
          receiveOrderConfirmation={receiveOrderConfirmation}
          userId={userId}
          campaignId={campaignId}
        />
        {isDesktop && <GlobalFooter />}
      </div>
      <PastDue isAccountPastDue={isAccountPastDue} />
    </>
  );
};

const mapStateToProps = (state) => ({
  viewSize: state.viewState.viewSize,
  trackingData: selectPageTrackingFullData(state),
  campaignId: state.campaignState.campaignId,
  user: state.userState,
});

const mapDispatchToProps = {
  receiveOrderConfirmation,
  receiveCampaign,
};

export default compose(
  withDocumentTitle,
  withViewSize,
  connect(mapStateToProps, mapDispatchToProps)
)(CheckoutPage);
